module.exports = __webpack_public_path__ + "img/tm_logo.de2cd3ef.png";